/** Production default — matches hybrid.js + client interceptor. */
export const DEFAULT_API_BASE = "https://app.weupsell.com";

/**
 * Resolve WeUpsell API origin for storefront runtime + preview bundle.
 * Priority mirrors extensions/popup-upsell/assets/hybrid.js getBaseURL().
 */
export function getApiBaseUrl() {
  if (typeof window !== "undefined") {
    const cfgUrl = window.weupsellConfig?.apiUrl;
    if (typeof cfgUrl === "string" && cfgUrl.trim()) {
      return cfgUrl.trim().replace(/\/+$/, "");
    }
  }

  const viteApi =
    typeof import.meta !== "undefined" && import.meta.env?.VITE_API_URL;
  if (viteApi && String(viteApi).trim()) {
    return String(viteApi).trim().replace(/\/+$/, "");
  }

  const viteApp =
    typeof import.meta !== "undefined" && import.meta.env?.VITE_APP_URL;
  if (viteApp && String(viteApp).trim()) {
    return String(viteApp).trim().replace(/\/+$/, "");
  }

  if (typeof process !== "undefined" && process.env?.REACT_APP_API_URL) {
    const legacy = String(process.env.REACT_APP_API_URL).trim();
    if (legacy) return legacy.replace(/\/+$/, "");
  }

  return DEFAULT_API_BASE;
}
